(function ( $ ) {

    $( document ).ready( function ( $ ) {

        /**
         * Animations function.
         */
        function animationsFunction() {

            // Header
            TweenMax.to($('.wrapper'), 0.8, {opacity: '1', ease: Power2.easeOut}).delay(0.2);

            // Gallery
            baguetteBox.run('.gallery', { animation: 'slideIn'});

        }

        /**
         * Nav function.
         */
        function navFunction() {

            $('.hamburger').on('click', function() {
               $('.mobile__menu').slideToggle();
            });

            $('.mobile .menu-item-has-children').find('a').first().on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $('.mobile .sub-menu').slideToggle();
            });

        }

        /**
         * Sliders function.
         */
        function slidersFunction() {

            // Home header
            $('#slider').carousel({
                interval: 3000
            });

            // News
            $('.news').slick({
                dots: true,
                arrows: false,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

            // Sponsors
            $('.sponsors').slick({
                dots: true,
                arrows: false,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

            // Events
            $('.events').slick({
                dots: true,
                arrows: false,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

        }

        /**
         * Contact function.
         */
        function contactFunction() {

            $('.wpcf7-list-item').on('click', function() {

                // Checkboxes
                if ($(this).find('input[type=checkbox]').is(':checked')) {
                    $(this).find('input[type=checkbox]').removeAttr('checked');
                } else {
                    $(this).find('input[type=checkbox]').attr('checked', 'checked');
                }

            });

        }

        /**
         * Cookie consent function.
         */
        function cookieConsentFunction() {

            var site_url = object_name.site_url;
            window.addEventListener('load', function() {
                window.cookieconsent.initialise({
                    'position': 'bottom-right',
                    'content': {
                        'message': 'Wij gebruiken cookies en andere tracking technologieën om data te verzamelen, gepersonaliseerde content en advertenties te maken en om onze traffiek te analyseren. Wij delen informatie over uw gebruik van onze site met onze sociale media, advertenties en analytics partners die het kunnen combineren met andere informatie die u aan hen hebt verstrekt.<br>',
                        'dismiss': 'Accepteren',
                        'link': 'Algemene voorwaarden',
                        'href': site_url + '/algemene-voorwaarden/'
                    }
                });
            });

        }

        /**
         * Fire off the functions.
         */
        animationsFunction();
        navFunction();
        slidersFunction();
        contactFunction();
        cookieConsentFunction();

    } );

})( jQuery );
